import React from 'react'
import logo from '../images/udevs_icon.svg'
import { FaLongArrowAltRight, FaEnvelope, FaPhone, FaTelegram } from 'react-icons/fa'

const Footer = ({ lang }) => (
    <footer>
        <div className="footer__heading">{lang === 'en' ? 'Questions?' : 'Вопросы?'}</div>
        <div className="footer__info">
            <p>{lang === 'en' ? 'We’re happy to answer questions about our products and services. All inquiries will be answered in the order they are received.' : 'Мы будем рады ответить на вопросы о наших продуктах и услугах. На все запросы будут даны ответы в порядке их получения.'}</p>
            <a href="https://t.me/azizbekbakhodirov" className="footer__contact" target="_blank" rel="noreferrer noopener">{lang === 'en' ? 'Contact Us' : 'Связаться'} <FaLongArrowAltRight size="19" /></a>
        </div>
        <div className="footer__rest">
            <div className="footer__corp">
                <img src={logo} alt="udevs" />
                <p>Udevs Corp, Inc. <br />{lang === 'en' ? 'All Rights Reserved' : 'Все права защищены'}</p>
            </div>
            <div className="footer__links">
                <a href="mailto:azizbekbakhodirov@gmail.com"><FaEnvelope /> Email</a>
                <a href="https://t.me/azizbekbakhodirov" target="_blank" rel="noreferrer noopener"><FaTelegram /> Telegram</a>
            </div>
            <div className="footer__links">
                <a href="tel:+998998150922"><FaPhone /> +99899 815 09 22</a>
            </div>
        </div>
    </footer>
)

export default Footer